export const baseurls = {
  main: process.env.REACT_APP_BACKEND_URL || "http://127.0.0.1:5000/api",
  payments: "http://127.0.0.1:5000/api",
};
export const handleAddressUrl = (pincode) => {
  return `https://data.opendatasoft.com/api/explore/v2.1/catalog/datasets/geonames-postal-code@public/records?select=*&where=%22${pincode}%22?api_key=f88922c47ff42845e1836b4872ef40e4ef882e4da0df198f45047d2d`;
};
export const apiRoutes = {
  auth: {
    login: { path: "/auth/login", reqType: "POST" },
    googleLogin: { path: "/auth/google", reqType: "POST" },
    generateOtp: { path: "/auth/otp", reqType: "POST" },
    changeOrg: { path: "/auth/changeorg", reqType: "POST" },
    validateInvitation: { path: "/auth/validateinvitation", reqType: "POST" },
    resendInvitation: { path: "/auth/resendinvitation", reqType: "POST" },
  },
  customerPortal: {
    generateOtp: { path: "/customer-portal/generate-otp", reqType: "POST" },
    login: { path: "/customer-portal/login", reqType: "POST" },
    invoices: { path: "/customer-portal/invoices", reqType: "GET" },
    proposals: { path: "/customer-portal/proposals", reqType: "GET" },
  },
  billingUnit: {
    get: { path: "/billingunit/", reqType: "GET" },
    getAll: { path: "/billingunit/all", reqType: "GET" },
    create: {
      path: "/billingunit/",
      reqType: "POST",
    },
    edit: { path: "/billingunit/", reqType: "PATCH" },
    delete: {
      path: "/billingunit/",
      reqType: "DELETE",
    },
  },
  objectCustomization: {
    get: { path: "/objectCustomizations", reqType: "GET" },
    customFields: {
      path: "/objectCustomizations/customFields",
      reqType: "PATCH",
    },
    publishCustomFields: {
      path: "/objectCustomizations/publishCustomFields",
      reqType: "POST",
    },
    discardCustomField: {
      path: "/objectCustomizations/discardCustomField",
      reqType: "DELETE",
    },
    customFieldStatus: {
      path: "/objectCustomizations/customFieldStatus",
      reqType: "PATCH",
    },
    updateCustomField: {
      path: "/objectCustomizations/updateCustomField",
      reqType: "PATCH",
    },
  },
  billingSettings: {
    get: { path: "/billingsettings", reqType: "GET" },
    create: {
      path: "/billingsettings",
      reqType: "POST",
    },
    edit: { path: "/billingsettings", reqType: "PATCH" },
    delete: {
      path: "/billingsettings",
      reqType: "DELETE",
    },
    changeStatus: {
      path: "/billingsettings/updateStatus",
      reqType: "PATCH",
    },
    createRun: {
      path: "/billingsettings/runs",
      reqType: "POST",
    },
    getRuns: {
      path: "/billingsettings/runs",
      reqType: "GET",
    },
  },
  data: {
    get: { path: "/data", reqType: "GET" },
  },
  organisation: {
    getOrganisationById: { path: "/organisation", reqType: "GET" },
  },
  feature: {
    get: { path: "/feature", reqType: "GET" },
    getAll: { path: "/feature/all", reqType: "GET" },
    create: { path: "/feature/", reqType: "POST" },
    edit: { path: "/feature/", reqType: "PATCH" },
    delete: { path: "/feature", reqType: "DELETE" },
  },
  contact: {
    get: { path: "/contact", reqType: "GET" },
    getByEmail: { path: "/contact/email", reqType: "GET" },
    getByOrgId: { path: "/contact/byOrgId", reqType: "GET" },
    overview: { path: "/contact/overview", reqType: "GET" },
    picker: { path: "/contact/picker", reqType: "GET" },
    create: { path: "/contact", reqType: "POST" },
    edit: { path: "/contact", reqType: "PATCH" },
    delete: { path: "/contact", reqType: "DELETE" },
  },

  market: {
    get: { path: "/market", reqType: "GET" },
    create: { path: "/market/", reqType: "POST" },
    edit: { path: "/market/", reqType: "PATCH" },
  },
  product: {
    get: { path: "/product", reqType: "GET" },
    initiate: { path: "/product/initiate", reqType: "POST" },
    edit: { path: "/product/", reqType: "PATCH" },
    archive: { path: "/product/archive", reqType: "PATCH" },
  },
  plan: {
    get: { path: "/plan", reqType: "GET" },
    initiate: { path: "/plan/initiate", reqType: "POST" },
    edit: { path: "/plan/", reqType: "PATCH" },
    archive: { path: "/plan/archive", reqType: "PATCH" },
    getBundlesWithPlans: { path: "/plan/getBundlesWithPlans", reqType: "GET" },
  },
  navCounts: { path: "/nav-counts", reqType: "GET" },
  bundles: {
    get: { path: "/bundle", reqType: "GET" },
    create: { path: "/bundle", reqType: "POST" },
    edit: { path: "/bundle", reqType: "PATCH" },
    changePlanOrder: { path: "/bundle/changeplanorder", reqType: "PATCH" },
    changeBundleOrder: { path: "/bundle/changeBundleOrder", reqType: "PATCH" },
  },
  subscription: {
    get: { path: "/subscription/", reqType: "GET" },
    create: { path: "/subscription/", reqType: "POST" },
    edit: { path: "/subscription/", reqType: "PATCH" },
    delete: { path: "/subscription/", reqType: "DELETE" },
    trialCompanyIds: { path: "/subscription/trial-company-ids", reqType: "GET" },
    selfServeSummary: { path: "/subscription/self-serve-summary", reqType: "GET" },
  },
  selfServeCheckouts: {
    getBundles: { path: "/selfservecheckout/bundles", reqType: "GET" },
    updateConfigurls: {
      path: "/selfservecheckout/configurls",
      reqType: "POST",
    },
    getConfigUrls: { path: "/selfservecheckout/configurls", reqType: "GET" },
    createSubscription: {
      path: "/selfservecheckout/createSubscription",
      reqType: "POST",
    },
    createTrialSubscription: {
      path: "/selfservecheckout/createTrialSubscription",
      reqType: "POST",
    },
    createTrialSetupIntent: {
      path: "/selfservecheckout/subscription/",
      reqType: "POST",
    },
    confirmTrialPaymentMethod: {
      path: "/selfservecheckout/subscription/",
      reqType: "POST",
    },
    overview: { path: "/selfservecheckout/overview", reqType: "GET" },
    getSelfServeUsers: {
      path: "/selfservecheckout/getselfserveusers",
      reqType: "GET",
    },
    logSelfServeUserStage: {
      path: "/selfservecheckout/loguserstage",
      reqType: "POST",
    },
    updateBillingCycles: {
      path: "/selfservecheckout/billingcycles",
      reqType: "POST",
    },

    getAllSelfServeUserById: {
      path: "/selfservecheckout/getselfserveuser",
      reqType: "GET",
    },

    createSelfserveuser: {
      path: "/selfservecheckout/selfserveuser",
      reqType: "POST",
    },
    editSelfserveuser: {
      path: "/selfservecheckout/selfserveuser",
      reqType: "PATCH",
    },
    createCompanyFormSelfserveUser: {
      path: "/selfservecheckout/createcompany",
      reqType: "POST",
    },
  },
  document: {
    get: { path: "/document-templates", reqType: "GET" },
    create: { path: "/document-templates", reqType: "POST" },
    edit: { path: "/document-templates", reqType: "PUT" },
    delete: { path: "/document-templates", reqType: "DELETE" },
    duplicate: { path: "/document-templates", reqType: "POST" },
    restore: { path: "/document-templates", reqType: "POST" },
    default: { path: "/document-templates", reqType: "POST" },
    publish: { path: "/document-templates", reqType: "POST" },
    preview: { path: "/document-templates", reqType: "POST" },
    render: { path: "/document-templates", reqType: "POST" },
    pdf: { path: "/document-templates", reqType: "POST" },
    versions: { path: "/document-templates", reqType: "GET" },
    rollback: { path: "/document-templates", reqType: "POST" },
  },

  integrations: {
    get: { path: "/integrations", reqType: "GET" },
    setDefaultPaymentGateway: {
      path: "/payments/setdefaultpaymentgateway",
      reqType: "POST",
    },
    paymentsDisconnect: { path: "/payments/disconnect", reqType: "DELETE" },
    changeUserIntegrationActiveStatus: {
      path: "/integrations/changeIntegrationStatus",
      reqType: "POST",
    },
    getRazorpayPaymentMethods: {
      path: "/payments/getConfiguredRazorpayPaymentMethods",
      reqType: "GET",
    },
    getStripePaymentMethods: {
      path: "/payments/getConfiguredStripePaymentMethods",
      reqType: "GET",
    },
    getStripeAchStatus: {
      path: "/payments/getStripeAchStatus",
      reqType: "GET",
    },
    getDefaultPaymentGateway: {
      path: "/payments/getdefaultpaymentgateway",
      reqType: "POST",
    },
    verifyMongodbCredentials: {
      path: "/usagesource/validatemongodbintegration",
      reqType: "POST",
    },
    // "Sync now" for an already-connected MongoDB integration - re-checks
    // the stored credentials still connect, rather than the previous fake sync.
    verifyMongoDbConnection: {
      path: "/usagesource/validatemongodbconnection",
      reqType: "POST",
    },
    getMongoDbCredentials: {
      path: "/usagesource/getmongodbcredentials",
      reqType: "GET",
    },
    disconnectMongodbIntegration: {
      path: "/usagesource/disconnectmongodbintegration",
      reqType: "DELETE",
    },
    verifySqlCredentials: {
      path: "/usagesource/validatesqlintegration",
      reqType: "POST",
    },
    // "Sync now" for an already-connected MySQL integration - same pattern
    // as verifyMongoDbConnection above.
    verifySqlConnection: {
      path: "/usagesource/validatesqlconnection",
      reqType: "POST",
    },
    getSqlCredentials: {
      path: "/usagesource/getsqlcredentials",
      reqType: "GET",
    },
    disconnectSqlIntegration: {
      path: "/usagesource/disconnectsqlintegration",
      reqType: "DELETE",
    },
    verifyGoogleSheetsCredentials: {
      path: "/integrations/verifygooglesheetscredentials",
      reqType: "POST",
    },
    // "Sync now" for an already-connected Google Sheets integration -
    // re-checks the stored sheet URL is still public/reachable.
    verifyGoogleSheetsConnection: {
      path: "/integrations/verifygooglesheetsconnection",
      reqType: "POST",
    },
    getGoogleSheetsCredentials: {
      path: "/integrations/getgooglesheetscredentials",
      reqType: "GET",
    },
    disconnectGoogleSheetsIntegration: {
      path: "/integrations/disconnectgooglesheets",
      reqType: "DELETE",
    },
    completeCustomWebsiteIntegration: {
      path: "/integrations/completecustomwebsiteintegration",
      reqType: "POST",
    },
    completeWebflowIntegration: {
      path: "/integrations/completewebflowintegration",
      reqType: "POST",
    },
    completeWixIntegration: {
      path: "/integrations/completewixintegration",
      reqType: "POST",
    },
    getWixIntegrationStatus: {
      path: "/integrations/getwixintegrationstatus",
      reqType: "GET",
    },
    disconnectWixIntegration: {
      path: "/integrations/disconnectwixintegration",
      reqType: "DELETE",
    },
    getWebflowIntegrationStatus: {
      path: "/integrations/getwebflowintegrationstatus",
      reqType: "GET",
    },
    disconnectWebflowIntegration: {
      path: "/integrations/disconnectwebflowintegration",
      reqType: "DELETE",
    },
    getCustomWebsiteIntegrationStatus: {
      path: "/integrations/getcustomwebsiteintegrationstatus",
      reqType: "GET",
    },
    disconnectCustomWebsiteIntegration: {
      path: "/integrations/disconnectcustomwebsiteintegration",
      reqType: "DELETE",
    },
    verifyAvalaraCredentials: {
      path: "/integrations/verifyavalaracredentials",
      reqType: "POST",
    },
    verifyAvalaraConnection: {
      path: "/integrations/verifyavalaraconnection",
      reqType: "POST",
    },
    disconnectAvalaraIntegration: {
      path: "/integrations/disconnectavalara",
      reqType: "DELETE",
    },
  },
  tax: {
    getProviderSettings: { path: "/tax/provider-settings", reqType: "GET" },
    setProviderSettings: { path: "/tax/provider-settings", reqType: "POST" },
  },
  razorpay: {
    validate: { path: "/payments/verifyrazorpaycredentials", reqType: "POST" },
    verifyConnection: { path: "/payments/verifyrazorpayconnection", reqType: "POST" },
    get: { path: "/payments/getrazorpaycredentials", reqType: "POST" },
    createOrder: { path: "/payments/create-order", reqType: "POST" },
    logPaymentData: { path: "/payments/log", reqType: "POST" },
    getPaymentRedirectUrls: {
      path: "/selfservecheckout/redirectUrls",
      reqType: "GET",
    },
  },
  stripe: {
    validate: { path: "/payments/verifystripecredentials", reqType: "POST" },
    verifyConnection: { path: "/payments/verifystripeconnection", reqType: "POST" },
    get: { path: "/payments/getstripecredentials", reqType: "POST" },
    createOrder: {
      path: "/payments/create-stripe-payment-intent",
      reqType: "POST",
    },
    createPaymentIntent: {
      path: "/payments/create-stripe-payment-intent",
      reqType: "POST",
    },
    logPaymentData: { path: "/payments/log", reqType: "POST" },
    verifySession: { path: "/payments/verifystripesession", reqType: "POST" },
  },
  usageSource: {
    validate: { path: "/usagesource/validateDatabase", reqType: "POST" },
    get: { path: "/usagesource", reqType: "GET" },
    getAll: { path: "/usagesource/all", reqType: "GET" },
    create: { path: "/usagesource/createsource", reqType: "POST" },
    edit: { path: "/usagesource/editsource", reqType: "PATCH" },
    updateStatus: { path: "/usagesource/editsource/status", reqType: "PATCH" },
  },
  usageCompilation: {
    checksource: { path: "/usagecompilation/checksource", reqType: "POST" },
    get: { path: "/usagecompilation", reqType: "GET" },
    getAll: { path: "/usagecompilation/all", reqType: "GET" },
    create: { path: "/usagecompilation/", reqType: "POST" },
    edit: { path: "/usagecompilation/", reqType: "PATCH" },
  },
  usageCollection: {
    get: { path: "/usagecollection", reqType: "GET" },
  },
  imports: {
    get: { path: "/imports", reqType: "GET" },
    getColumns: { path: "/imports/columns", reqType: "POST" },

    uploadcsv: { path: "/imports/uploadcsv", reqType: "POST" },
    updateFieldMapping: {
      path: "/imports/updatefieldmapping",
      reqType: "POST",
    },
    upload: { path: "/imports/upload", reqType: "POST" },
    validateImportData: {
      path: "/imports/validateimportdata",
      reqType: "POST",
    },
    downloadSampleCsv: {
      path: "/imports/downloadimportdata",
      reqType: "GET",
    },
    job: { path: "/imports/job", reqType: "GET" },
    file: { path: "/imports", reqType: "GET" },
  },
  migrations: {
    create: { path: "/migrations", reqType: "POST" },
    list: { path: "/migrations", reqType: "GET" },
    get: { path: "/migrations", reqType: "GET" },
    entities: { path: "/migrations", reqType: "GET" },
    uploadEntityFile: { path: "/migrations", reqType: "POST" },
    advance: { path: "/migrations", reqType: "POST" },
    completeness: { path: "/migrations", reqType: "GET" },
    acknowledgeOutcome: { path: "/migrations", reqType: "POST" },
    parallelRun: { path: "/migrations", reqType: "POST" },
    job: { path: "/migrations/job", reqType: "GET" },
    reconciliation: { path: "/migrations", reqType: "GET" },
    resolveDiscrepancy: { path: "/migrations/discrepancies", reqType: "PATCH" },
    cutover: { path: "/migrations", reqType: "POST" },
    rollback: { path: "/migrations", reqType: "POST" },
  },
  customers: {
    get: { path: "/customers", reqType: "GET" },
  },
  company: {
    tab: { path: "/company/tab", reqType: "GET" },
    tabCounts: { path: "/company/tab-counts", reqType: "GET" },
    atRisk: { path: "/company/at-risk", reqType: "GET" },
    get: { path: "/company", reqType: "GET" },
    getAllCompanyMetrics: { path: "/company", reqType: "GET" },
    create: { path: "/company", reqType: "POST" },
    edit: { path: "/company", reqType: "PATCH" },
    delete: { path: "/company", reqType: "DELETE" },
  },
  user: {
    get: { path: "/user", reqType: "GET" },
    create: { path: "/user", reqType: "POST" },
    edit: { path: "/user", reqType: "PATCH" },
    editOnboardingOwner: { path: "/user/onboarding", reqType: "PATCH" },
  },
  proposal: {
    get: { path: "/proposal", reqType: "GET" },
    create: { path: "/proposal", reqType: "POST" },
    edit: { path: "/proposal", reqType: "PATCH" },
    changeStatus: { path: "/proposal/changeStatus", reqType: "PATCH" },
    getCustomerProposal: { path: "/proposal/company", reqType: "POST" },
    getAllProposals: { path: "/proposal", reqType: "GET" },
    tab: { path: "/proposal/tab", reqType: "GET" },
    stats: { path: "/proposal/stats", reqType: "GET" },
    defaults: { path: "/proposal/defaults", reqType: "GET" },
    getAllCompanyProposals: { path: "/proposal/company", reqType: "GET" },
    delete: { path: "/proposal", reqType: "DELETE" },
    createSubscription: {
      path: "/proposal/createSubscription",
      reqType: "POST",
    },
  },

  logs: {
    payments: { path: "/logs/payments", reqType: "GET" },
    paymentMetrics: { path: "/logs/paymentMetrics", reqType: "GET" },
    companyPayments: { path: "/logs/payments/company", reqType: "GET" },
  },
  dunning: {
    listRetryPlans: { path: "/dunning", reqType: "GET" },
  },
  invoice: {
    create: { path: "/invoice", reqType: "POST" },
    resend: { path: "/invoice/resend", reqType: "POST" },
    logPaymentData: { path: "/invoice/logInvoicePayment", reqType: "POST" },
    get: { path: "/invoice", reqType: "get" },
    pastDueCompanies: { path: "/invoice/past-due-companies", reqType: "get" },
    getInvoicePayment: { path: "/invoice/getinvoicepayment", reqType: "get" },
    createSubscription: {
      path: "/invoice/createSubscription",
      reqType: "POST",
    },
    writeoff: { path: "/invoice/writeoff", reqType: "POST" },
    preview: { path: "/invoice/preview", reqType: "POST" },
  },
  webhook: {
    sendFeatures: { path: "/webhook/sendfeatures", reqType: "POST" },
    regenerateCredentials: {
      path: "/webhook/regeneratecredentials",
      reqType: "POST",
    },
    get: { path: "/webhook/", reqType: "GET" },
    editRedirectUrls: { path: "/webhook/redirecturls", reqType: "PUT" },
    editOutgoingWebhooks: { path: "/webhook/outgoingwebhooks", reqType: "PUT" },
    userBillingData: { path: "/webhook/userbillingdata", reqType: "POST" },
    subscriptionBuids: { path: "/webhook/subscription-buids", reqType: "GET" },
  },
  // Public API keys (scoped credentials for /api/simplify). Revoke is DELETE /apikeys/:id.
  apiKeys: {
    list: { path: "/apikeys", reqType: "GET" },
    create: { path: "/apikeys", reqType: "POST" },
    revoke: { path: "/apikeys", reqType: "DELETE" },
  },
  monthlyRecurringRevenue: {
    getCompany: { path: "/monthlyrecurringrevenue/company", reqType: "GET" },
  },
  revenue: {
    cmrr: { path: "/revenue/cmrr", reqType: "GET" },
    mrrGrowth: { path: "/revenue/mrr-growth", reqType: "GET" },
    selfServeMrr: { path: "/revenue/self-serve-mrr", reqType: "GET" },
    addOnMrr: { path: "/revenue/add-on-mrr", reqType: "GET" },
    addOnAttach: { path: "/revenue/add-on-attach", reqType: "GET" },
    usageRevenue: { path: "/revenue/usage-revenue", reqType: "GET" },
  },
  platformSettings: {
    get: { path: "/platformSettings", reqType: "GET" },
    createandUpdate: { path: "/platformSettings", reqType: "POST" },
  },
  usageConsumption: {
    getUsageConsumptionOfSubscriptions: {
      path: "/usageconsumption/getsubscriptionconsumption",
      reqType: "POST",
    },
  },
  upsell: {
    getSubscriptions: { path: "/upsell/getsubscription", reqType: "POST" },
    get: { path: "/upsell", reqType: "GET" },
    stats: { path: "/upsell/stats", reqType: "GET" },
    defaults: { path: "/upsell/defaults", reqType: "GET" },
    create: { path: "/upsell", reqType: "POST" },
    resend: { path: "/upsell/resend", reqType: "POST" },
    preview: { path: "/upsell/preview", reqType: "POST" },
    edit: { path: "/upsell", reqType: "PATCH" },
    changeStatus: { path: "/upsell/status", reqType: "PATCH" },
    approve: { path: "/customerapprovals/:id/approve", reqType: "PATCH" },
    reject: { path: "/customerapprovals/:id/reject", reqType: "PATCH" },
    getApprovals: { path: "/customerapprovals", reqType: "GET" },
    getAllWithApprovals: { path: "/upsell/with-approvals", reqType: "GET" },
  },
  wallet: {
    getBalance: { path: "/wallet/company/:companyId/balance", reqType: "GET" },
  },
};
